// extracted by mini-css-extract-plugin
export default {"muteNotifications":"MuteNotifications-module__muteNotifications___CyrOB","bell":"MuteNotifications-module__bell___JIALu","newIcon":"MuteNotifications-module__newIcon___cYyxW"};